import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import { fillParentHeight } from './utility.styles';

export const dialogPaper: SystemStyleObject<Theme> = {
  ...fillParentHeight,
};
